const permittedOrigins = import.meta.env.REACT_APP_PERMITTED_ORIGINS?.split('|') || [];
/**
 * Validates that the current origin is in the list of permitted origins
 * @returns The current origin if it's permitted
 * @throws Error if the current origin is not permitted
 */
export function getValidatedOrigin(): string {
  const currentOrigin = window.location.origin;

  if (!permittedOrigins.includes(currentOrigin)) {
    throw new Error(`Origin ${currentOrigin} is not in the permitted origins list: ${permittedOrigins.join(', ')}`);
  }
  return currentOrigin;
}

/**
 * Checks if the current origin is in the list of permitted origins
 * @returns true if the current origin is permitted, false otherwise
 */
export function isPermittedOrigin(): boolean {
  try {
    getValidatedOrigin();
    return true;
  } catch {
    return false;
  }
}
